import BaseApiService from '@/services/common/api/baseApiService';

class SuppliersService extends BaseApiService {
  completeRegistration(completeRegistrationInfo) {
    return this.makeRequest(this.httpClient
      .put(this.apiRoutes.activateAccount, completeRegistrationInfo));
  }

  validateConfirmationToken(token) {
    return this.makeRequest(this.httpClient
      .get(this.apiEndPointsBuilder.validateActivateAccountToken(token)));
  }

  registerSupplier(supplier) {
    return this.makeRequest(this.httpClient
      .post(this.apiRoutes.supplierRegister, supplier));
  }
}

export default SuppliersService;
